import { render } from "./CZEnergyMarketPriceReport.vue?vue&type=template&id=5d804be6&scoped=true&ts=true"
import script from "./CZEnergyMarketPriceReport.vue?vue&type=script&lang=ts"
export * from "./CZEnergyMarketPriceReport.vue?vue&type=script&lang=ts"

import "./CZEnergyMarketPriceReport.vue?vue&type=style&index=0&id=5d804be6&scoped=true&lang=css"

import exportComponent from "C:\\Develop\\Czone_UI_EIC\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d804be6"]])

export default __exports__